module.exports = __webpack_public_path__ + "static/img/product_2_2.ce204f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_2_2.png
// module id = 507F
// module chunks = 34